<template>
  <span
    :class="[
      'ui-inline-block ui-px-3xs ui-py-3xs ui-text-white ui-text-xs ui-font-bold ui-text-center ui-self-end',
      backgroundColor,
      { 'ui-px-xs': type === 'deal' },
    ]"
    :style="{ clipPath: clipPathValue }"
    :data-testid="`product-banner-${type}`"
    v-html="bannerText"
  />
</template>

<script lang="ts" setup>
import { computed } from "vue";

interface Props {
  type: "deal" | "clearance" | "deal-1line";
}

const props = defineProps<Props>();

const clipPathValue =
  "polygon(7.08% 0%, 0% 21%, 0% 100%, 100% 100%, 100% 0%, 29.89% 0%)";

const backgroundColor = computed(() => {
  switch (props.type) {
    case "deal": {
      return "ui-bg-blue-dark";
    }
    case "deal-1line": {
      return "ui-bg-blue-dark";
    }
    case "clearance": {
      return "ui-bg-red-dark";
    }
    default: {
      return "";
    }
  }
});

const bannerText = computed(() => {
  switch (props.type) {
    case "deal": {
      return "SPECIAL<br>OFFER";
    }
    case "deal-1line": {
      return "SPECIAL OFFER";
    }
    case "clearance": {
      return "CLEARANCE";
    }
    default: {
      return "";
    }
  }
});
</script>
